var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Quill from 'quill';
var embed = Quill.import('blots/embed');
var TemplatePlaceholderNotAllowedEmbed = /** @class */ (function (_super) {
    __extends(TemplatePlaceholderNotAllowedEmbed, _super);
    function TemplatePlaceholderNotAllowedEmbed() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TemplatePlaceholderNotAllowedEmbed.create = function (options) {
        var node = _super.create.call(this);
        node.setAttribute('data-placeholder-type', options.type);
        node.innerText = options.text;
        node.classList.add('bg-light-gray', 'line-through', 'text-charcoal', 'px-xxxs');
        return node;
    };
    TemplatePlaceholderNotAllowedEmbed.value = function (node) {
        return {
            type: node.getAttribute('data-placeholder-type'),
            text: node.innerText,
        };
    };
    TemplatePlaceholderNotAllowedEmbed.blotName = 'TemplatePlaceholderNotAllowedEmbed';
    TemplatePlaceholderNotAllowedEmbed.className = 'ql-template-placeholder-not-allowed';
    TemplatePlaceholderNotAllowedEmbed.tagName = 'span';
    return TemplatePlaceholderNotAllowedEmbed;
}(embed));
export { TemplatePlaceholderNotAllowedEmbed };
